import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "file-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, " File Attachments ", -1)
const _hoisted_3 = { class: "file-uploaders-container" }
const _hoisted_4 = { class: "file-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, " Tenant Consent Form ", -1)
const _hoisted_6 = { class: "file-uploaders-container" }

import FileUpload from '../ui/inputs/file-upload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'document-upload',
  props: {
    /** 
     * Determines if the component control should be in read-only mode.
     * @type {boolean}
     * @default false
     */
    readOnly: {
        type: Boolean,
        default: false
    },

    /** 
     * Controls whether only TCF (specific data or format) should be displayed.
     * @type {boolean}
     * @default false
     */
    onlyShowTcf: {
        type: Boolean,
        default: false
    },

    /** 
     * Indicates if the component should trigger a reset action.
     * @type {boolean}
     * @default false
     */
    reset: {
        type: Boolean,
        default: false
    },
    /** Indicates the maximum size of a file in bytes that can be uploaded.
     * When set to 0, there is no max size.
     * @type {Number}
     * @default 0
     */
    maxFileSize: {
        type: Number, 
        default: 0
    }
},
  emits: [
    /** 
     * Emits an event when the list of documents is changed.
     * This is used to notify the parent component about document updates.
     * @param {File[]} e - The updated list of files.
     */
    'documentsChanged',
    /** 
     * Emits an event when the TCF (specific file type or format) is changed.
     * This is used to notify the parent component about TCF-related updates.
     * @param {File[]} e - The updated list of TCF files.
     */
    'tcfChanged'
],
  setup(__props, { emit }) {





/** Handles the Files Changed event of the Document upload component */
const onDocumentsChanged = (e: File[]) => {
    emit('documentsChanged', e)
}

/** Handles the Files Change event of the TCF upload component */
const onTcfChanged = (e: File[]) => {
    emit('tcfChanged', e);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.onlyShowTcf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(FileUpload, {
              text: "Upload Files",
              "read-only": __props.readOnly,
              onFilesChanged: onDocumentsChanged,
              reset: __props.reset,
              "max-file-size": __props.maxFileSize
            }, null, 8, ["read-only", "reset", "max-file-size"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(FileUpload, {
          text: "Upload TCF",
          multiple: false,
          "read-only": __props.readOnly,
          onFilesChanged: onTcfChanged,
          reset: __props.reset,
          "max-file-size": __props.maxFileSize
        }, null, 8, ["read-only", "reset", "max-file-size"])
      ])
    ])
  ], 64))
}
}

})